import { render, staticRenderFns } from "./SlideOptionImageButton.vue?vue&type=template&id=3ddb3061&scoped=true&"
import script from "./SlideOptionImageButton.vue?vue&type=script&lang=js&"
export * from "./SlideOptionImageButton.vue?vue&type=script&lang=js&"
import style0 from "./SlideOptionImageButton.vue?vue&type=style&index=0&id=3ddb3061&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb3061",
  null
  
)

export default component.exports